<span [ngClass]="{ 'countdown-timer-hide': !showTimer }">
  <span *ngIf="!completed; else showComplete" class="countdown-timer fw-bold">
    {{ formattedTime$ | async }}
  </span>
  <ng-template #showComplete>
    <span>
      {{ completeText }}
    </span>
  </ng-template>
</span>
